<template>
  <div>
    <div
      v-if="loading"
      class="mt-3 overview_items-wrapper"
    >
      <div
        v-for="item in Array.from({ length: 15 }, (_, i) => i + 1)"
        :key="item"
        class="shimmer-box"
      ></div>
    </div>
    <div v-else>
      <OverviewCards
        :ppp-active-sessions="pppActiveSessions"
        :single-user-db-data="singleUserDbData"
        :description="description"
        :total-rx="totalRx"
        :total-tx="totalTx"
        :olt-connect-olt-name="oltConnectOltName"
        :vendor="vendor"
        :temperature-onu="temperatureOnu"
        :last-update="lastUpdate"
        :last-dereg-reason="lastDeregReason"
        :alive-time="aliveTime"
        :port-number="portNumber"
        :down-count="downCount"
        :refresh-loader="refreshLoader"
        @fetch-history-data="$emit('fetch-history-data', $event)"
      />
      <PreviousDbmCards :single-user-db-data="singleUserDbData" />
      <ChartSection
        :chart-data="chartData"
        :loader="loader"
        :loadernew="loadernew"
        :dashoard-chart-data="dashboardChartData"
        :seleced-index="selectedIndex"
        @filer="handleFiler"
      />
    </div>
  </div>
</template>

<script>
import OverviewCards from "./OverviewCards.vue";
import PreviousDbmCards from "./PreviousDbmCards.vue";
import ChartSection from "./ChartSection.vue";

export default {
  name: "OverviewTab",
  components: {
    OverviewCards,
    PreviousDbmCards,
    ChartSection,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    pppActiveSessions: {
      type: Array,
      default: () => [],
    },
    singleUserDbData: {
      type: Object,
      default: () => ({}),
    },
    description: {
      type: String,
      default: null,
    },
    totalRx: {
      type: String,
      default: null,
    },
    totalTx: {
      type: String,
      default: null,
    },
    oltConnectOltName: {
      type: String,
      default: "",
    },
    vendor: {
      type: String,
      default: null,
    },
    temperatureOnu: {
      type: String,
      default: "",
    },
    lastUpdate: {
      type: String,
      default: null,
    },
    lastDeregReason: {
      type: String,
      default: null,
    },
    aliveTime: {
      type: String,
      default: null,
    },
    portNumber: {
      type: String,
      default: null,
    },
    downCount: {
      type: String,
      default: "",
    },
    refreshLoader: {
      type: Boolean,
      default: false,
    },
    chartData: {
      type: Object,
      default: null,
    },
    loader: {
      type: Boolean,
      default: true,
    },
    loadernew: {
      type: Boolean,
      default: false,
    },
    dashboardChartData: {
      type: Array,
      default: () => [],
    },
    selectedIndex: {
      type: [String, Number],
      default: "All",
    },
  },
  methods: {
    handleFiler(date, index) {
      console.log('OverviewTab: Forwarding filer event', { date, index });
      this.$emit('filer', date, index);
    },
  },
};
</script>

<style scoped>

.shimmer-box {
  width: 100%;
  height: 100px; /* Adjust height as needed */
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 3.5s infinite linear;
  border-radius: 4px;
  margin-bottom: 10px; /* Adjust spacing */
}

.dark-mode .shimmer-box {
  background: linear-gradient(90deg, #586b836e 25%, #213550 50%, #34476736 75%);
  background-size: 200% 100%;
  animation: shimmer 3.5s infinite linear;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>

